import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Firebase config
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Link } from 'react-router-dom';

const HalalMarketsPage = () => {
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    country: '',
    city: '',
    marketType: '',
    minPrice: 0,
    maxPrice: 1000,
  });

  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchMarkets = async () => {
      try {
        setLoading(true);

        let q = query(collection(db, 'halalMarkets'));

        if (filters.country) {
          q = query(q, where('country', '==', filters.country));
        }

        if (filters.city) {
          q = query(q, where('city', '==', filters.city));
        }

        if (filters.marketType) {
          q = query(q, where('marketType', '==', filters.marketType));
        }

        if (filters.minPrice && filters.maxPrice) {
          q = query(
            q,
            where('price', '>=', filters.minPrice),
            where('price', '<=', filters.maxPrice)
          );
        }

        const querySnapshot = await getDocs(q);
        const marketList = [];
        querySnapshot.forEach((doc) => {
          marketList.push({ id: doc.id, ...doc.data() });
        });

        setMarkets(marketList);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching halal markets:', err);
        setLoading(false);
      }
    };

    fetchMarkets();
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredMarkets = markets.filter((market) =>
    market.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return <div className="text-center mt-20 text-xl">جارٍ تحميل الأسواق الحلال...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-lg mx-auto mb-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">أسواق حلال</h2>

        {/* شريط البحث */}
        <div className="mb-4">
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="ابحث بالاسم..."
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>

        {/* نموذج الفلاتر */}
        <div className="space-y-4">
          {/* البلد */}
          <div>
            <label className="block text-sm font-medium text-gray-600">البلد</label>
            <input
              type="text"
              name="country"
              value={filters.country}
              onChange={handleFilterChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="أدخل البلد"
            />
          </div>

          {/* المدينة */}
          <div>
            <label className="block text-sm font-medium text-gray-600">المدينة</label>
            <input
              type="text"
              name="city"
              value={filters.city}
              onChange={handleFilterChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="أدخل المدينة"
            />
          </div>

          {/* نوع السوق */}
          <div>
            <label className="block text-sm font-medium text-gray-600">نوع السوق</label>
            <input
              type="text"
              name="marketType"
              value={filters.marketType}
              onChange={handleFilterChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="أدخل نوع السوق (مثل السوبر ماركت، المحلي)"
            />
          </div>

          {/* نطاق السعر */}
          <div className="flex space-x-4">
            <div className="w-1/2">
              <label className="block text-sm font-medium text-gray-600">أقل سعر</label>
              <input
                type="number"
                name="minPrice"
                value={filters.minPrice}
                onChange={handleFilterChange}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                min="0"
                placeholder="أقل سعر"
              />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-medium text-gray-600">أعلى سعر</label>
              <input
                type="number"
                name="maxPrice"
                value={filters.maxPrice}
                onChange={handleFilterChange}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                min="0"
                placeholder="أعلى سعر"
              />
            </div>
          </div>
        </div>
      </div>

      {/* قائمة الأسواق */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredMarkets.map((market) => (
          <div key={market.id} className="bg-white p-6 rounded-lg shadow-lg">
            {/* الصورة */}
            {market.picture ? (
              <img
                src={market.picture}
                alt={`${market.name} الصورة`}
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
            ) : (
              <div className="w-full h-48 bg-gray-300 rounded-lg mb-4 flex items-center justify-center text-gray-600">
                لا توجد صورة
              </div>
            )}

            {/* الاسم */}
            <h3 className="text-xl font-semibold text-gray-800">{market.name}</h3>

            {/* تفاصيل السوق */}
            <p className="text-gray-600 mt-2">{market.description}</p>

            {/* السعر */}
            <p className="text-gray-700 mt-2">نطاق السعر: دج{market.price}</p>
            

            {/* الموقع */}
            <p className="text-gray-600 mt-2">
              {market.city}, {market.country}
            </p>

            {/* رابط لصفحة التفاصيل */}
            <Link
              to={`/halal-market/${market.id}`}
              className="mt-4 inline-block text-green-600 hover:text-green-700"
            >
              عرض التفاصيل
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HalalMarketsPage;
